/**
 *  @swagger
 *  definitions:
 *    ChampionshipSubscriptionParams:
 *      type: object
 *      properties:
 *        ChampionshipId:
 *          description: ID of the associated Championship
 *          type: string
 *        CrewmemberId:
 *          description: ID of the associated Crewmember
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    ChampionshipSubscriptionCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipSubscriptionParams'
 *        - type: object
 *          required:
 *            - ChampionshipId
 *            - CrewmemberId
 *
 *  @swagger
 *  definitions:
 *    ChampionshipSubscriptionQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the ChampionshipSubscription
 *              type: string
 *        - $ref: '#/definitions/ChampionshipSubscriptionParams'
 *
 *  @swagger
 *  definitions:
 *    ChampionshipSubscriptionUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipSubscriptionQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    ChampionshipSubscription:
 *      allOf:
 *        - $ref: '#/definitions/ChampionshipSubscriptionCreateParams'
 *        - $ref: '#/definitions/ChampionshipSubscriptionUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      ChampionshipSubscription:
 *        allOf:
 *          - $ref: '#/definitions/ChampionshipSubscription'
 *          - type: object
 *            properties:
 *              Championship:
 *                description: Championship of the ChampionshipSubscription
 *                $ref: '#/components/schemas/Championship'
 *              Crewmember:
 *                description: Crewmember of the ChampionshipSubscription
 *                $ref: '#/components/schemas/Crewmember'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  ChampionshipId: string;
  CrewmemberId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Championship?: $Model<'Championship'>;
  Crewmember?: $Model<'Crewmember'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'ChampionshipSubscription'> => {
  const ChampionshipSubscription = stack.define(
    'ChampionshipSubscription',
    fields(Sequelize),
    {
      tableName: 'ChampionshipSubscriptions',
    },
  );

  ChampionshipSubscription.associate = (models: $ModelClasses) => {
    models.ChampionshipSubscription.belongsTo(
      models.Championship,
      {
        as: 'Championship',
        foreignKey: 'ChampionshipId',
      },
    );
    models.ChampionshipSubscription.belongsTo(
      models.Crewmember,
      {
        as: 'Crewmember',
        foreignKey: 'CrewmemberId',
      },
    );
  };

  ChampionshipSubscription.addScope(
    'defaultScope',
    {
      order: [['createdAt', 'ASC']],
    },
  );

  return ChampionshipSubscription;
});
